import { render, staticRenderFns } from "./history.vue?vue&type=template&id=8e813c50&scoped=true"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"
import style0 from "./history.vue?vue&type=style&index=0&id=8e813c50&prod&lang=scss"
import style1 from "./history.vue?vue&type=style&index=1&id=8e813c50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e813c50",
  null
  
)

export default component.exports